export function stripMarkdownBackLink(text: string): string {
  const lines = text.split('\n');

  let firstNonEmptyIndex = -1;

  for (let index = 0; index < lines.length; index += 1) {
    if (lines[index].trim().length > 0) {
      firstNonEmptyIndex = index;
      break;
    }
  }

  if (firstNonEmptyIndex === -1) {
    return text;
  }

  const firstLine = lines[firstNonEmptyIndex].trim();

  const isBackLink =
    firstLine.startsWith('[← Back') && firstLine.includes('](index.md)');

  if (!isBackLink) {
    return text;
  }

  const nextIndex = firstNonEmptyIndex + 1;
  const shouldSkipNext =
    nextIndex < lines.length && lines[nextIndex].trim().length === 0;

  const startSlice = lines.slice(0, firstNonEmptyIndex);
  const endSlice = lines.slice(firstNonEmptyIndex + (shouldSkipNext ? 2 : 1));
  return [...startSlice, ...endSlice].join('\n');
}

export function normalizeMarkdownCallouts(text: string): string {
  const lines = text.split('\n');
  const normalizedLines: string[] = [];
  const calloutStartPattern = /^!!!\s+([a-zA-Z]+)(?:\s+"([^"]+)")?\s*$/;
  const fencePattern = /^(```|~~~)/;

  let index = 0;
  let isInFence = false;

  while (index < lines.length) {
    const currentLine = lines[index];

    if (fencePattern.test(currentLine.trim())) {
      isInFence = !isInFence;
      normalizedLines.push(currentLine);
      index += 1;
      continue;
    }

    if (isInFence) {
      normalizedLines.push(currentLine);
      index += 1;
      continue;
    }

    const calloutMatch = currentLine.match(calloutStartPattern);

    if (!calloutMatch) {
      normalizedLines.push(currentLine);
      index += 1;
      continue;
    }

    const calloutType = calloutMatch[1].toLowerCase();
    const calloutTitle = calloutMatch[2]?.trim();
    const calloutBody: string[] = [];

    index += 1;

    while (index < lines.length) {
      const bodyLine = lines[index];
      const isEmptyLine = bodyLine.trim().length === 0;

      if (bodyLine.startsWith('    ')) {
        calloutBody.push(bodyLine.slice(4));
        index += 1;
        continue;
      }

      if (bodyLine.startsWith('\t')) {
        calloutBody.push(bodyLine.slice(1));
        index += 1;
        continue;
      }

      if (isEmptyLine) {
        calloutBody.push('');
        index += 1;
        continue;
      }

      break;
    }

    const marker = calloutTitle
      ? `[!${calloutType}|${calloutTitle}]`
      : `[!${calloutType}]`;

    normalizedLines.push(`> ${marker}`);
    normalizedLines.push('>');

    calloutBody.forEach(line => {
      if (line.length === 0) {
        normalizedLines.push('>');
        return;
      }
      normalizedLines.push(`> ${line}`);
    });
  }

  return normalizedLines.join('\n');
}

export function getHeadingId(text: string): string | undefined {
  const normalized = text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  if (normalized.length === 0) {
    return undefined;
  }

  return normalized;
}
